export enum AttendanceRateStatus {
  Excellent = 'excellent',
  OnTrack = 'on track',
  BelowTarget = 'below target',
}

export enum TutorCategoryType {
  PaidMath = 'PAID_MATH',
  PaidEla = 'PAID_ELA',
  DemoMath = 'DEMO_MATH',
  DemoEla = 'DEMO_ELA',
}

export enum TutorPolicyBookingType {
  Paid = 'PAID',
  Demo = 'DEMO',
}

